'use strict';

import angular from 'angular';

import saFetchErrorMessage from './fetch_error_message.directive';

export default angular
  .module('common.fetchErrorMessage', [])
  .directive('saFetchErrorMessage', saFetchErrorMessage)
  .name;



// WEBPACK FOOTER //
// ./app/src/common/fetch_error_message/index.js